import { jsx as r, jsxs as f } from "react/jsx-runtime";
import "react";
import { classes as l } from "../../../utils/helpers.js";
import { StringList as C } from "../../StringList/StringList.js";
import { AirDateSegment as e } from "./AirDateSegment.js";
import { ImageCard as y } from "../../ImageCard/ImageCard.js";
import { Concat as $ } from "../../Concat/Concat.js";
import { determineProgramTitle as n } from "../../../utils/program-helpers.js";
function N({ scheduleItem: i, styles: o, strListArr: a, handleClicks: p, determineCTA: m }) {
  var t;
  const s = i.episode_number ? `${i.episode_number}:` : "", g = i.program_synopsis !== null ? i.program_synopsis : "", _ = [
    i.title_name.trim() !== n(i).trim() ? `<div>${s} ${i.title_name}</div>` : "",
    i.program_synopsis !== null ? `<div>${g}</div>` : "",
    /* @__PURE__ */ r(C, { list: a, separatorType: "pipe" })
  ];
  return /* @__PURE__ */ f("li", { className: l([o["schedule-list__item"], "schedule-list__item"]), children: [
    /* @__PURE__ */ r(e, { scheduleItem: i, styles: o }),
    /* @__PURE__ */ r(
      y,
      {
        id: i.id,
        image: {
          url: ((t = i == null ? void 0 : i.content) == null ? void 0 : t.image) ?? "",
          altText: "",
          aspectRatio: 543 / 305
        },
        title: n(i),
        content: /* @__PURE__ */ r($, { list: _ }),
        cta: m(i),
        clampContentLines: !0,
        numberOfLinesToClamp: 5,
        displayInline: !0,
        handleClicks: p
      }
    )
  ] }, `schedule-list-${i.id}`);
}
export {
  N as SeriesItem,
  N as default
};
